import React from "react";
import Countdown from "react-countdown";

import { useGeneralContext } from "../../context/GeneralContext";
import * as S from "./styles";

// react-countdown doc: https://github.com/ndresx/react-countdown

const CountdownBar = ({ text = "" }) => {
  const { promoEnd } = useGeneralContext();

  return (
    <S.Wrapper>
      <S.Paragraph>{text}</S.Paragraph>
      <S.Counter>
        <Countdown date={promoEnd} daysInHours={true} />
      </S.Counter>
    </S.Wrapper>
  );
};

export default CountdownBar;
